<template>
  <q-layout view="lHh lpr lff">
    <LayoutHeader />
    <q-page-container>
      <router-view />
    </q-page-container>

    <q-drawer
      v-model="showDrawer"
      side="right"
      overlay
    >
      <q-scroll-area class="fit bg-primary">
        <LayoutNav class="q-py-md" />
      </q-scroll-area>
    </q-drawer>

    <LayoutFooter />
  </q-layout>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import LayoutHeader from 'components/layout/Header';
import LayoutFooter from 'components/layout/Footer';
import LayoutNav from 'components/layout/Nav';

export default {
  components: {
    LayoutNav,
    LayoutFooter,
    LayoutHeader,
  },

  computed: {
    ...mapState('layout', { drawerIsVisible: 'showDrawer' }),

    showDrawer: {
      get() {
        return this.drawerIsVisible;
      },
      set() {
        this.closeDrawer();
      },
    },
  },

  methods: {
    ...mapMutations('layout', ['closeDrawer']),
  },
};
</script>
